import React, { Component } from "react";
import RecordsComponent from "../../components/dashboard/RecordsComponent";
import { getAcceptedColor } from "../../../helpers/helperMethods";

export class RecordsContainer extends Component {
  render() {
    const { isUpdating, role, recordsToDisplay } = this.props;
    const records = [
      {
        title: "Blogs",
        count: recordsToDisplay.blogs,
        icon: "post_add",
        color: getAcceptedColor(0).hexColor,
      },
      {
        title: "Newsletters",
        count: recordsToDisplay.newsletters,
        icon: "article",
        color: getAcceptedColor(1).hexColor,
      },
      {
        title: "Photos",
        count: recordsToDisplay.photoGalleries,
        icon: "photo_library",
        color: getAcceptedColor(2).hexColor,
      },
      {
        title: "Videos",
        count: recordsToDisplay.videoGalleries,
        icon: "video_library",
        color: getAcceptedColor(3).hexColor,
      },

      {
        title: "Subscribers",
        count: recordsToDisplay.subscribers,
        icon: "group_add",
        color: getAcceptedColor(4).hexColor,
      },
      {
        title: "Posted Jobs",
        count: recordsToDisplay.postedJobs,
        icon: "work",
        color: getAcceptedColor(5).hexColor,
      },
      {
        title: "Partners",
        count: recordsToDisplay.partners,
        icon: "handshake",
        color: getAcceptedColor(6).hexColor,
      },
      {
        title: "Reports",
        count: recordsToDisplay.reports,
        icon: "summarize",
        color: getAcceptedColor(7).hexColor,
      },
    ];

    return (
      <>
        <RecordsComponent
          role={role}
          records={records}
          isUpdating={isUpdating}
        />
      </>
    );
  }
}

export default RecordsContainer;
